/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Collection of roles that an address can take.
 * Can be multiple.
 */
export enum EnumAddressRole {
    /**
     * This address represents a debtor
     */
    Debtor = 1,
    /**
     * This address represents a creditor
     */
    Creditor = 2,
    /**
     * This address represents an interested party
     */
    InterestedParty = 3,
    /**
     * This address represents a disposal site
     */
    Disposal = 4,
    /**
     * This address represents a point of origin
     */
    Origin = 5,
    /**
     * This address represents a carrier
     */
    Carrier = 6,
    /**
     * This address represents a private party
     */
    Private = 7,
}
